import React from "react";
import IndividualUserForms from "../../components/UI/AllWebCheckInForms/IndividualUserForms";

export function CustomerDetails() {
  return (
    <>
      <div>
        <IndividualUserForms />
      </div>
    </>
  );
}
